import { Box, styled, Theme, Typography } from '@mui/material';
import { palette } from 'view/themes/palette';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';

export const CreateJobPostHeader = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    height: '88px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '8px',

    /* [theme.breakpoints.down('laptop')]: {
      justifyContent: 'space-between',
    }, */
  };
}) as typeof Box;

export const CreateJobPostMainScrollableWrapper = styled(Box)<{ isScrollable: boolean }>(({
  theme,
  isScrollable,
}) => {
  return {
    width: '100%',
    height: 'calc(100vh - 282px)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: isScrollable ? 'initial' : 'flex-start', // ✅ Меняем alignItems
    overflowY: 'auto',
    /* paddingRight: '4px', */

    '&::-webkit-scrollbar': { width: '4px' },
    '&::-webkit-scrollbar-thumb': {
      background: '#D8DBE8',
      borderRadius: '10px',
      transition: 'background 0.2s ease-in-out',
    },
    '&::-webkit-scrollbar-thumb:hover': { background: '#BFC3D4' },
    '&::-webkit-scrollbar-thumb:active': { background: '#A5AABF' },

    [theme.breakpoints.down('desktop')]: {
      height: 'calc(100vh - 406px)',
    },

    [theme.breakpoints.down('laptop')]: {
      height: 'max-content',
      marginBottom: '100px',
    },
  };
});

export const CreateJobPostMainWrapper = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    maxWidth: '440px', // TODO NEED TO RESEARCH
    width: '100%',
    height: 'max-content',

    [theme.breakpoints.down('tablet')]: {
      maxWidth: '100%',
    },
  };
}) as typeof Box;

export const CreateJobPostMainHeader = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    marginBottom: '32px',

    [theme.breakpoints.down('tablet')]: {
      alignItems: 'flex-start',
    },
  };
}) as typeof Box;

export const CreateJobPostMainHeaderTitle = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    color: palette.text.header,
    fontWeight: 700,
    fontSize: '32px',
    lineHeight: '38px',
    textAlign: 'center',

    [theme.breakpoints.down('tablet')]: {
      fontSize: '24px',
    },
  };
}) as typeof Typography;

export const CreateJobPostMainHeaderSubTitle = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    color: palette.text.body,
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '22px',
    textAlign: 'center',
    whiteSpace: 'pre-line',

    [theme.breakpoints.down('tablet')]: {
      textAlign: 'start',
      whiteSpace: 'initial',
    },
  };
}) as typeof Typography;

export const CJPSubmitBtnWrapper = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '440px',
    display: 'flex',
    gap: '10px',
    position: 'absolute',
    bottom: '0',
    left: '50%',
    transform: 'translate(-50%, 0)',

    [theme.breakpoints.down('tablet')]: {
      width: '100%',
      padding: '0 16px',
      backgroundColor: palette.white,
    },
  };
}) as typeof Box;

export const CJPBackButtonBox = styled(Box)({
  width: 'max-content',
  flexShrink: 0,
}) as typeof Box;

export const StepLabelText = styled(StepLabel)(({ theme }: { theme: Theme }) => {
  return {
    padding: 0,
    marginBottom: '32px',

    '.MuiStepLabel-iconContainer': {
      paddingRight: '0',

      '.MuiSvgIcon-root': {
        width: '32px',
        height: '32px',
        color: 'transparent',
        border: '1px solid #D8DBE8',
        borderRadius: '50%',
        opacity: '0.5',

        '.MuiStepIcon-text': {
          fontWeight: 700,
          fontSize: '14px',
          lineHeight: '19px',
          fill: '#D8DBE8',
        },

        '&.Mui-active': {
          color: '#85C553',
          border: 'none',
          opacity: '1',
          letterSpacing: '1px',
          '.MuiStepIcon-text': {
            fill: '#fff',
          },
        },

        '&.Mui-completed': {
          color: '#85C553',
          border: 'none',
          opacity: '1',
          letterSpacing: '1px',
          backgroundColor: '#fff',
        },
      },
    },

    '.MuiStepLabel-labelContainer': {
      '.MuiStepLabel-label': {
        color: palette.white,
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: '21px',
        opacity: 0.5,

        '&.Mui-active': {
          opacity: 1,
        },

        '&.Mui-completed': {
          opacity: 1,
        },
      },
    },
  };
});

export const CustomStepper = styled(Stepper)(({ theme }: { theme: Theme }) => {
  return {
    width: '320px',

    '.MuiStep-root': {
      flex: 'initial',
      paddingLeft: '0',
      paddingRight: '16px',
    },

    '.MuiStepConnector-root': {
      marginLeft: '0!important',
      top: '15px',
      left: 'calc(-50% + 8px)',
      right: 'calc(50% + 24px)',

      '.MuiStepConnector-line': {
        borderTopWidth: '3px',
        borderColor: '#D8DBE8',
      },

      '&.Mui-disabled': {
        marginLeft: '0!important',
      },
    },
  };
});
